import React from "react";
import {
  Document,
  Font,
  Image,
  Link,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import Application from "../../../../../database/models/application-form/bosnia/Application";
import ieee from "../../../../../shared/resources/ieee-logo-bih.png";

interface IProps {
  data: Data;
}

interface Data {
  fileName: string;
  application: Application;
}

const Preview = (props: IProps) => {
  const { application, fileName } = props.data;
  return (
    <Document>
      <Page style={styles.body}>
        <View style={styles.imageWrapper}>
          <Image style={styles.image} src={ieee} />
        </View>

        <Text style={styles.title}>IEEE Innovation Nation BIH 2020</Text>
        <Text style={styles.subtitle}></Text>

        <Text style={styles.subHeader}>Personal Information</Text>
        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>
            Full Name: <Text style={styles.answer}>{application.fullName}</Text>
          </Text>
        </View>
        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>
            Date of birth:{" "}
            <Text style={styles.answer}>
              {`${application.dob.getMonth() +
                1}/${application.dob.getDate()}/${application.dob.getFullYear()}`}
            </Text>
          </Text>
        </View>
        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>
            Email Address:{" "}
            <Text style={styles.answer}>{application.email}</Text>
          </Text>
        </View>
        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>
            Phone Number:{" "}
            <Text style={styles.answer}>{application.contact}</Text>
          </Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            Current place of residence (example: Tuzla, Banja Luka, Sarajevo
            etc)
          </Text>
          <Text style={styles.answer}>{application.placeOfResidence}</Text>
        </View>
        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>
            Who are you?{" "}
            <Text style={styles.answer}>{application.whoYouAre}</Text>
          </Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            What are you studying and/or where are you employed? (If student -
            please list what you are studying currently ex. computer science,
            marketing), If you work in a company please list it)
          </Text>
          <Text style={styles.answer}>{application.whatYouAreStudying}</Text>
        </View>
        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>CV/Resume: </Text>
          <Link src={application.cvLink} style={styles.link}>
            {fileName}
          </Link>
        </View>
      </Page>
      <Page style={styles.body}>
        <Text style={styles.subHeader}>Key selection criteria</Text>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            Motivation - What is your motivation to want to participate in the
            program and what do you hope to achieve?
          </Text>
          <Text style={styles.answer}>{application.motivation}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            Commitment - This program will require you to invest at least 10
            hours per week in it. What makes you believe you are committed to
            completing the program?
          </Text>
          <Text style={styles.answer}>{application.commitment}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            Past experience - What past experiences do you have that make you a
            good candidate for a scholarship in this program?
          </Text>
          <Text style={styles.answer}>{application.pastExperience}</Text>
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber }) => `[${pageNumber}]`}
          fixed
        />
      </Page>
    </Document>
  );
};

Font.register({
  family: "Oswald",
  src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 10,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    color: "#00629b",
    textAlign: "center",
    fontFamily: "Oswald",
  },
  subtitle: {
    fontSize: 12,
    textAlign: "center",
    color: "#00629b",
    marginBottom: 10,
    paddingBottom: 10,
    borderBottomColor: "#333",
    borderBottomWidth: 1,
    borderColor: "#00629b",
  },
  fieldWrapperInline: {
    flexDirection: "row",
    alignContent: "flex-start",
    flexShrink: 1,
    margin: 10,
  },
  fieldWrapperTwoline: {
    flexDirection: "column",
    margin: 10,
  },
  subHeader: {
    margin: 10,
    fontWeight: 900,
    fontSize: 16,
    fontFamily: "Times-Bold",
  },
  subHeaderTwo: {
    margin: 10,
    fontWeight: 900,
    fontSize: 14,
    fontFamily: "Times-Bold",
  },
  question: {
    fontWeight: 900,
    fontSize: 12,
    fontFamily: "Times-Bold",
    marginRight: 5,
    marginBottom: 3,
  },
  answer: {
    fontSize: 12,
    fontFamily: "Times-Roman",
    marginRight: 10,
    textAlign: "justify",
  },
  image: {
    width: 100,
    textAlign: "center",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  imageWrapper: {
    flexDirection: "row",
    justifyContent: "center",
  },
  link: {
    fontSize: 12,
    fontFamily: "Times-Roman",
    textAlign: "justify",
    color: "blue",
    textDecoration: "underline",
  },
});

export default Preview;
